var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUiUxIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.19366 20.3078C5.62316 20.3078 5.05782 20.1821 4.49766 19.9308C3.93732 19.6794 3.47066 19.3435 3.09766 18.923C3.47966 18.814 3.84116 18.5823 4.18216 18.2278C4.52316 17.8734 4.69366 17.4001 4.69366 16.8078C4.69366 16.1089 4.93566 15.5176 5.41966 15.0338C5.90366 14.5498 6.49499 14.3078 7.19366 14.3078C7.89249 14.3078 8.48382 14.5498 8.96766 15.0338C9.45166 15.5176 9.69366 16.1089 9.69366 16.8078C9.69366 17.7731 9.35166 18.5978 8.66766 19.2818C7.98382 19.9658 7.15916 20.3078 6.19366 20.3078ZM11.5014 14.75L9.27066 12.5193L17.8359 3.95402C18.0192 3.77068 18.2484 3.67485 18.5234 3.66652C18.7984 3.65818 19.0359 3.75402 19.2359 3.95402L20.0667 4.78477C20.2667 4.98477 20.3667 5.2181 20.3667 5.48477C20.3667 5.75143 20.2667 5.98477 20.0667 6.18477L11.5014 14.75Z",
    fill: "#4D4D53"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUiUxIcon);
export default __webpack_public_path__ + "static/media/ui-ux-icon.8f6f6e0bea84ce3a36fc1eb5d38b654f.svg";
export { ForwardRef as ReactComponent };